import instance from "@/services/apiService";
import apiUrls from "@/services/apiUrls";
import store from "@/store";

/**
 * eStore Products List
 */
// Service Sale / Alacarte-sale
const getServiceSales = () =>
  instance.get(
    `${apiUrls.SERVICE_SALES}?branch=${store.getters.selectedBranch.id}&sort=name`
  );

// Retail Product
const getRetailProducts = () =>
  instance.get(
    `${apiUrls.RETAIL_PRODUCTS}?branch=${store.getters.selectedBranch.id}&sort=name`
  );

// Coupon
const getCoupons = () =>
  instance.get(
    `${apiUrls.COUPONS}?branch=${store.getters.selectedBranch.id}&sort=name`
  );

/**
 * eStore Popular Products List
 */
// Popular Service Sale / Alacarte-sale
const getPopularServiceSales = () =>
  instance.get(
    `${apiUrls.POPULAR_SERVICE_SALES}?limit=5&branch=${store.getters.selectedBranch.id}`
  );

// Popular Retail Product
const getPopularRetailProducts = () =>
  instance.get(
    `${apiUrls.POPULAR_RETAIL_PRODUCTS}?limit=5&branch=${store.getters.selectedBranch.id}`
  );

// Popular Coupon
const getPopularCoupons = () =>
  instance.get(
    `${apiUrls.POPULAR_COUPONS}?limit=5&branch=${store.getters.selectedBranch.id}`
  );

export {
  getServiceSales,
  getRetailProducts,
  getCoupons,
  getPopularServiceSales,
  getPopularRetailProducts,
  getPopularCoupons,
};
